import React from 'react'

export default function Graph() {
  return (
    <section className='graph comp'>
        <div className="stream-line">
          <div className="step">You send a request with the username</div>
          <div className="step">The server sends a response with the data</div>
          <div className="step">We display the data for you</div>
        </div>
    </section>
  )
}
